import { getEmptyUrlGeneratorMap } from './emptyUrlGeneratorMap.js';
export const getRouting = () => {
    return global.urlGeneratorMap || getEmptyUrlGeneratorMap();
};
export const storeRouting = (value) => {
    global.urlGeneratorMap = value;
};
//# sourceMappingURL=RoutingRepository.js.map